import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const requestCheckFile = getMessageFactoryV2({
  code: "REQUEST_CHECK_FILE"
});
export { requestCheckFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/requestCheckFile.js